<template>
  <div :class="{ 'content-container': !customerID }">
    <el-breadcrumb separator="/" v-if="!customerID">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>上报信息</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20" v-if="search">
      <div class="filter">
        <el-form :model="filter" ref="filterForm" label-position="right" label-width="75px">
          <div class="filter-block">
            <el-form-item label="客户名称" v-if="!customerID">
              <customer-select :val="filter.customer_id" @change="filter.customer_id = $event"></customer-select>
            </el-form-item>
            <el-form-item label="上报人角色">
              <el-select style="width: 100%" v-model="filter.user_role_name" size="small" placeholder="请选择角色"
                @change="filter.user_id = 0">
                <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上报人">
              <UserSelect size="small" :allResource="true" :val="filter.user_id" :role="filter.user_role_name"
                @change="filter.user_id = $event" ref="userSelect"></UserSelect>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="filter.status" size="small">
                <el-option :value="0" key="0" label="不限"></el-option>
                <el-option :value="1" key="1" label="未处理"></el-option>
                <el-option :value="2" key="2" label="已处理"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上报日期">
              <el-date-picker v-model="filter.date" type="daterange" size="small" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="维护日期">
              <el-date-picker v-model="filter.maintain_date" type="daterange" size="small" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </div>
        </el-form>
        <div class="mt-10 flex-row-between" style="margin-left: 75px">
          <div>
            <el-button type="primary" size="small" @click="
              filter.page = 1
            requestCustomerIssueList()
              ">筛选</el-button>
            <el-button size="small" @click="reset()">重置</el-button>
          </div>
        </div>
      </div>
    </div>
    <div :class="{ 'panel mt-20': search }">
      <div class="header flex-row-between">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="startCustomerIssueFormer()"
          v-if="hasAuth('customerIssueNew') || hasAuth('serviceQuestFlow')">添加信息上报</el-button>
        <file-button class="mobile-hide" obj="customer_issue_device" style="float: right" :filter="filter"
          :importButton="false" exportBtnName="导出客户设备" v-if="!customerID"></file-button>
      </div>
      <el-table v-if="!isMobile()" :data="lists" stripe>
        <el-table-column prop="customer.name" label="客户名" v-if="!customerID">
          <template slot-scope="scope">
            <customer-link :customer="scope.row.customer" :dealer="false"></customer-link>{{ scope.row.customer_name }}
          </template>
        </el-table-column>
        <el-table-column prop="desc" label="描述"></el-table-column>
        <el-table-column prop="imgs" label="图片">
          <template slot-scope="scope">
            <auth-img tag="el-image" v-for="item in scope.row.imgs" :preview-src-list="scope.row.imgs" :key="item"
              :src="item" :thumbnail="true" fit="cover" style="width: 40px; height: 40px; margin-right: 4px"></auth-img>
          </template>
        </el-table-column>
        <el-table-column prop="desc" align="center" label="商机类型">
          <template slot-scope="scope">
            {{
              BusinessOpportunityTypeMap[scope.row.business_opportunity_type] ||
              '无'
            }}
          </template>
        </el-table-column>
        <el-table-column prop="user.name" label="上报人" align="center"></el-table-column>
        <el-table-column prop="created_at" label="上报时间" align="center">
          <template slot-scope="scope">
            {{ $time(scope.row.created_at).format('YYYY-MM-DD HH:mm') }}
          </template>
        </el-table-column>
        <el-table-column label="状态(维护日期)" align="center">
          <template slot-scope="scope">
            {{ scope.row.status == 1 ? '待处理' : '已处理' }}
            <div v-if="scope.row.status == 2">
              {{ $time(scope.row.updated_at).format('YYYY-MM-DD') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="260" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.status == 1">
              <el-popconfirm class="mr-5" title="确认删除该信息吗？" v-if="
                (hasAuth('customerIssueDelete') ||
                  hasAuth('serviceQuestFlow')) &&
                userInfo.id == scope.row.user_id
              " @confirm="deleteIssue(scope.row.id, scope.$index)">
                <el-button slot="reference" type="danger" plain size="mini">删除</el-button>
              </el-popconfirm>
              <el-button v-if="
                (hasAuth('customerIssueEdit') ||
                  hasAuth('serviceQuestFlow')) &&
                (userInfo.id == scope.row.user_id || hasAuth('customerIssueFinish'))
              " type="primary" class="mr-5" size="mini" plain
                @click="startCustomerIssueFormer(scope.row, scope.$index)">编辑</el-button>
              <el-popconfirm title="确定已完成处理吗？" @confirm="handleFinishCustomerIssue(scope.row.id, scope.$index)"
                v-permission="Auth.customerIssueFinish">
                <el-button slot="reference" type="primary" plain size="mini">完成处理</el-button>
              </el-popconfirm>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <ul v-else class="list-style mt-20">
        <li v-for="(item, index) in lists" :key="item.id">
          <div>
            <div v-if="!customerID">
              客户名：<customer-link :customer="item.customer" :dealer="false"></customer-link>{{ item.customer_name }}
            </div>
            <div>
              上报时间：{{ $time(item.created_at).format('YYYY-MM-DD HH:mm') }}
            </div>
            <div>上报人：{{ item.user.name }}</div>
            <div>处理状态：{{ item.status == 1 ? '未处理' : '已处理' }}{{ item.status == 2 ?
              ` - ${$time(item.updated_at).format('YYYY-MM-DD')}` : '' }}</div>
            <div>上报描述：{{ item.desc }}</div>
            <div>
              商机类型：{{
                BusinessOpportunityTypeMap[item.business_opportunity_type]
              }}
            </div>
            <div>
              <auth-img tag="el-image" v-for="url in item.imgs" :preview-src-list="item.imgs" :key="url" :src="url"
                :thumbnail="true" fit="cover" style="width: 40px; height: 40px; margin-right: 4px"></auth-img>
            </div>
          </div>
          <div class="mt-10" v-if="item.status == 1">
            <el-popconfirm class="mr-5" title="确认删除该信息吗？" v-if="
              (hasAuth('customerIssueDelete') ||
                hasAuth('serviceQuestFlow')) &&
              userInfo.id == item.user_id
            " @confirm="deleteIssue(item.id, index)">
              <el-button slot="reference" type="danger" plain size="mini">删除</el-button>
            </el-popconfirm>
            <el-button v-if="
              (hasAuth('customerIssueEdit') || hasAuth('serviceQuestFlow')) &&
              userInfo.id == item.user_id
            " type="primary" class="mr-5" size="mini" plain
              @click="startCustomerIssueFormer(item, index)">编辑</el-button>
            <el-popconfirm title="确定已完成处理吗？" @confirm="handleFinishCustomerIssue(item.id, index)"
              v-permission="Auth.customerIssueFinish">
              <el-button slot="reference" type="primary" plain size="mini">完成处理</el-button>
            </el-popconfirm>
          </div>
        </li>
        <p v-if="lists.length == 0" class="mt-20 text-gray font-12">暂无数据</p>
      </ul>
      <el-pagination class="mt-20" :page-size="filter.size" :current-page.sync="filter.page"
        layout="total, prev, pager, next" :total="total"></el-pagination>
      <CustomerIssueFormer :model="customerIssueForm" :inner="customerID > 0"
        :show.sync="createCustomerIssueFormVisible" @created="createdCustomerIssue" @updated="updatedCustomerIssue">
      </CustomerIssueFormer>
    </div>
  </div>
</template>

<script>
import {
  roleList,
  customerIssueList,
  deleteCustomerIssue,
  finishCustomerIssue,
} from '@/service/getData'
import CustomerIssueFormer from '@/components/customer_issue'
import CustomerSelect from '@/components/select/customer_select'
import UserSelect from '@/components/select/user_select'
import { isMobile } from '@/util/index'
import { BusinessOpportunityTypeMap } from '@/config/global'

import { clone } from '@/util'
import { hasAuth } from '@/permission'
import store from '@/store/store'

export default {
  props: {
    customerID: {
      type: Number,
      default: 0,
    },
    orderID: {
      type: Number,
      default: 0,
    },
    search: {
      type: Boolean,
      default: true,
    },
  },
  components: { CustomerIssueFormer, CustomerSelect, UserSelect },
  data() {
    return {
      BusinessOpportunityTypeMap,
      userInfo: store.getters.userInfo,
      roles: [],
      filter: {
        date: '',
        maintain_date: '',
        customer_id: this.customerID,
        user_role_name: '',
        user_id: 0,
        status: 0,
        size: 10,
        page: 1,
      },
      hasAuth,
      isMobile,
      lists: [],
      customerIssueForm: {},
      editContactIndex: 0,
      createCustomerIssueFormVisible: false,
      total: 0,
    }
  },
  watch: {
    customerID: function () {
      if (this.customerID) {
        this.requestCustomerIssueList()
      }
    },
    'filter.page': function () {
      this.requestCustomerIssueList()
    },
  },
  created() {
    if (isMobile()) {
      this.filter.user_id = this.userInfo.id
    }
    this.requestCustomerIssueList()
    this.getRoles()
  },
  methods: {
    startCustomerIssueFormer(contact, index) {
      if (contact) {
        this.customerIssueForm = clone(contact)
        this.editContactIndex = index
      } else {
        this.customerIssueForm = {
          customer_name: '',
          customer_id: this.customerID,
          service_quest_id: this.orderID,
          business_opportunity_type: null,
          desc: '',
          imgs: [],
        }
      }
      this.createCustomerIssueFormVisible = true
    },
    async requestCustomerIssueList() {
      let data = this.clone(this.filter)
      data.page -= 1

      if (data.date) {
        data.start_date = data.date[0]
        data.end_date = data.date[1]
      }

      let res = await customerIssueList(data)

      this.lists = res.data.list
      this.total = res.data.total
    },
    async getRoles() {
      let res = await roleList()
      if (res.code == 0) {
        this.roles = res.data.list.filter((item) => item.status == 1)
      }
    },
    updatedCustomerIssue(contact) {
      this.lists.splice(this.editContactIndex, 1, contact)
    },
    createdCustomerIssue(contact) {
      this.lists.unshift(contact)
    },
    async deleteIssue(id, index) {
      let res = await deleteCustomerIssue(id)
      if (res.code == 0) {
        this.lists.splice(index, 1)
      }
    },

    async handleFinishCustomerIssue(id, index) {
      let res = await finishCustomerIssue(id)
      if (res.code == 0) {
        this.lists[index].status = res.data.status
      }
    },
    reset() {
      this.filter.page = 1
      this.filter.customer_id = this.customerID
      this.filter.user_role_name = ''
      this.filter.user_id = 0
      this.filter.date = ''
      this.filter.maintain_date = ''
      this.filter.status = 0
      this.requestCustomerIssueList()
    },
  },
}
</script>